import { CmtsComplaintRegisterGrid } from "../components/complaints/CmtsComplaintRegisterGrid.js";
import type { ComponentDiagnostic } from "@swot/base-components";
import type { ComplaintSummaryDto } from "../../types/complaint.types.js";

type CmtsComplaintRegisterPageProps = {
  readonly records?: readonly ComplaintSummaryDto[];
  readonly loading?: boolean;
  readonly error?: string | null;
  readonly diagnostics?: readonly ComponentDiagnostic[] | undefined;
  readonly permissionContext?: unknown;
  readonly onSelect?:
    ((record: ComplaintSummaryDto) => void | Promise<void>) | undefined;
  readonly onOpenWorkflow?:
    ((record: ComplaintSummaryDto) => void | Promise<void>) | undefined;
  readonly onOpenEvidence?:
    ((record: ComplaintSummaryDto) => void | Promise<void>) | undefined;
  readonly onExport?:
    | ((payload: {
        readonly rows?: readonly ComplaintSummaryDto[] | undefined;
      }) => void | Promise<void>)
    | undefined;
};

export function CmtsComplaintRegisterPage(
  props: CmtsComplaintRegisterPageProps,
) {
  return (
    <CmtsComplaintRegisterGrid
      records={props.records}
      loading={props.loading}
      error={props.error}
      onSelect={props.onSelect}
      onOpenWorkflow={props.onOpenWorkflow}
      onOpenEvidence={props.onOpenEvidence}
      onExport={props.onExport}
    />
  );
}
